import { render } from "./HostUsbDevicesTransfer.vue?vue&type=template&id=3e33e52a&scoped=true"
import script from "./HostUsbDevicesTransfer.vue?vue&type=script&lang=js"
export * from "./HostUsbDevicesTransfer.vue?vue&type=script&lang=js"

import "./HostUsbDevicesTransfer.vue?vue&type=style&index=0&id=3e33e52a&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e33e52a"]])

export default __exports__